import { AppState } from "../AppState";
import { isCompanyAdmin, isLocationAdmin, isPortalAdmin, isSiteAdmin } from "./isAdminRole";
import UserAccessSettings from "./UserAccessSettings";

const defaultMenuSetting: UserAccessSettings = {
  authenticated: false,
  canShowNotification: false,
  canShowOrphanedResults: false,
  canShowRolePermissionSubscription: false,
  isCompanyAdmin: false,
  isLocationAdmin: false,
  isPortalAdmin: false,
  isSiteAdmin: false,
  superUser: false,
  canManageTeam: false,//isClient || isClinic || isSiteAdmin... isClinic = portaladmin, isClient= company admin
  canViewOrder: false,
  canViewSiteSearch: false,
  canViewOrderTrackingGrid: false,
  canViewPersonnel: false,
  canEditPersonnel: false,
  canManagePools: false,
  canManagePersonnel: false,
  canManageSelectionInbox: false,
  canShowInvitationStatus: false,
  canInviteClientUser: false,
  canCreateClient: false,
  canManageClient: false,
  canShowPortal: false,
  canSearchDefaults: false,
  CanManageGovPools: false,
  CanManageConsortiumPools: false,
  CanManageGovDonors: false,
  CanOrderGovServices: false,
  canCompleteEvents: false,
  canVieweCCFCopy2PreMRO: false,
  canViewMISReports: false,
  canEditPendingOrders: false,
  canMergeTests: false,
  canMatchTests: false
}

export function BuildUserAccess(state?: AppState): UserAccessSettings {
  const menuSetting: UserAccessSettings = { ...defaultMenuSetting }

  menuSetting.authenticated = state?.Workforce1State?.isLoggedIn === true

  if (state?.Workforce1State.currentUserPermissions) {
    const perm = state.Workforce1State.currentUserPermissions;
    menuSetting.canShowNotification = perm.CanShowNotification;
    menuSetting.canShowPortal = perm.CanShowPortal;
  }

  if (state?.Workforce1State.currentCompanyPermissions) {
    menuSetting.canShowNotification = state.Workforce1State.currentCompanyPermissions.CanShowNotification;
    menuSetting.canViewOrder = state.Workforce1State.currentCompanyPermissions.CanViewOrder;
    menuSetting.canViewSiteSearch = state.Workforce1State.currentCompanyPermissions.CanViewSiteSearch;
    menuSetting.canViewOrderTrackingGrid = state.Workforce1State.currentCompanyPermissions.CanViewOrderTrackingGrid;
    menuSetting.canViewPersonnel = state.Workforce1State.currentCompanyPermissions.CanViewPersonnel;
    menuSetting.canEditPersonnel = state.Workforce1State.currentCompanyPermissions.CanEditPersonnel;
    menuSetting.canManagePools = state.Workforce1State.currentCompanyPermissions.CanManagePools;
    menuSetting.canManagePersonnel = state.Workforce1State.currentCompanyPermissions.CanManagePersonnel;
    menuSetting.canManageSelectionInbox = state.Workforce1State.currentCompanyPermissions.CanManageSelectionInbox;
    menuSetting.canShowInvitationStatus = state.Workforce1State.currentCompanyPermissions.CanShowInvitationStatus;
    menuSetting.canInviteClientUser = state.Workforce1State.currentCompanyPermissions.CanInviteClientUser;
    menuSetting.canCreateClient = state.Workforce1State.currentCompanyPermissions.CanCreateClient;
    menuSetting.canManageClient = state.Workforce1State.currentCompanyPermissions.CanManageClient;
    menuSetting.canShowRolePermissionSubscription = state.Workforce1State.currentCompanyPermissions.CanShowRolePermissionSubscription;
    menuSetting.canShowOrphanedResults = state.Workforce1State.currentCompanyPermissions.CanManageOrphanResults;
    menuSetting.canShowPortal = state.Workforce1State.currentCompanyPermissions.CanShowPortal;
    menuSetting.canSearchDefaults = state.Workforce1State.currentCompanyPermissions.CanSearchDefaults;
    menuSetting.CanManageGovPools = state.Workforce1State.currentCompanyPermissions.CanManageGovPools;
    menuSetting.CanManageConsortiumPools = state.Workforce1State.currentCompanyPermissions.CanManageConsortiumPools;
    menuSetting.CanManageGovDonors = state.Workforce1State.currentCompanyPermissions.CanManageGovDonors;
    menuSetting.CanOrderGovServices = state.Workforce1State.currentCompanyPermissions.CanOrderGovServices;
    menuSetting.canCompleteEvents = state.Workforce1State.currentCompanyPermissions.CanCompleteEvents;
    menuSetting.canVieweCCFCopy2PreMRO = state.Workforce1State.currentCompanyPermissions.CanVieweCCFCopy2PreMRO;
    menuSetting.canViewMISReports = state.Workforce1State.currentCompanyPermissions.CanViewMISReports;
    menuSetting.canEditPendingOrders = state.Workforce1State.currentCompanyPermissions.CanEditPendingOrders;
    menuSetting.canMergeTests = state.Workforce1State.currentCompanyPermissions.CanMergeTests;
    menuSetting.canMatchTests = state.Workforce1State.currentCompanyPermissions.CanMatchTests;
  }

  if (state?.Workforce1State.role) {
    const isSiteAdminVal = isSiteAdmin(state);
    const isCompAdminVal = isCompanyAdmin(state);
    const isPortalAdminVal = isPortalAdmin(state);
    const isLocationAdminVal = isLocationAdmin(state)

    menuSetting.isSiteAdmin = isSiteAdminVal;
    menuSetting.canManageTeam = isSiteAdminVal || isCompAdminVal || isPortalAdminVal || isLocationAdminVal;
    menuSetting.isCompanyAdmin = isCompAdminVal;
    menuSetting.isPortalAdmin = isPortalAdminVal;
    menuSetting.isLocationAdmin = isLocationAdminVal
  }

  return menuSetting;
}
